import { get } from "lodash";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import Header from "shared/components/Header";
import ProcessStepper from "shared/components/ProcessStepper";
import { useCompanySearch } from "shared/components/ScreenRenderer/useCompanySearch";
import { NAME_SPACES } from "shared/locales/constants";
import { STEP_INDEXES } from "../constants";
import { mergeSafeList, withoutNil } from "../helpers";
import View from "./View";

const Company = ({ project, onNext }) => {
  const [nextLoading, setNextLoading] = useState(false);
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.PROJECT);
  const TRANSLATION = t("DETAIL.TEMPLATES.ACORIS_COLLECTIVE", {
    returnObjects: true,
  });
  const { setQuery, results } = useCompanySearch();

  const stored = get(project, "fields.company", {});

  const [initialValues] = useState(() => ({
    company: {
      siret: null,
      siren: null,
      legalName: null,
      legalForm: null,
      street: null,
      zipCode: null,
      city: null,
      phone: null,
      email: null,
      nafCode: null,
      headcountTier: null,
      ccn: null,
      creationDate: null,
      ...stored,
      idcc: withoutNil(get(stored, "idcc")),
    },
  }));

  const onSubmit = ({ company }) => {
    setNextLoading(true);
    onNext({
      payload: {
        fields: {
          ...get(project, "fields", {}),
          company: {
            ...company,
            idcc: mergeSafeList(get(company, "idcc"), get(stored, "idcc")),
          },
        },
      },
      onCompleted: () => setNextLoading(false),
    });
  };

  const steps = useMemo(
    () => Object.values(TRANSLATION.STEPS).map((title) => ({ title })),
    [TRANSLATION],
  );

  return (
    <>
      <Header
        key="header"
        title={TRANSLATION.COMPANY.TITLE}
        subtitle={TRANSLATION.COMPANY.SUBTITLE}
        actions={[]}
      />
      <ProcessStepper
        steps={steps}
        current={STEP_INDEXES.COMPANY}
        aria-label={TRANSLATION.STEPPER_LABEL}
      />
      <View
        translation={TRANSLATION}
        initialValues={initialValues}
        onSubmit={onSubmit}
        nextLoading={nextLoading}
        searchResults={results}
        onSearch={setQuery}
        disabled={get(project, "expired") || get(project, "locked")}
      />
    </>
  );
};

export default Company;
